window.SendToToastForm = function ($scope, $q, posIntegrationService, brandServices) {

    var self = this;
    var formName = 'send-to-toast-form';
    var _protected = BaseForm.call(self, formName, $scope);

    self.pos_type = posIntegrationService.POS_TYPES.POS_TOAST_SYNC;

    self.positions = {};
    self.mappedEmployeePositions = {};
    self.submitDisabled = true;
    self.showConfirm = false;
    self.syncWages = false;
    self.differentPayTypeWarrning = false;
    self.showMissingDataWarrning = false;

    self.PAY_TYPES = {
        SALARIED: {code: 'SALARIED', name: "Salaried"},
        HOURLY: {code: 'HOURLY', name: "Hourly"},
    };
    self.payTypes = [
        {code: 'SALARIED', name: "Salaried"},
        {code: 'HOURLY', name: "Hourly"},
    ];

    var mapEmployeePositionsToToastPositions = function (employeePositions, toastMappedPositions) {
        var employeeMappedPositions = [];

        for (var j in employeePositions) {
            var mappedToastPosition = _.find(toastMappedPositions, function (item) {
                return item.code === employeePositions[j].position.code;
            });

            employeeMappedPositions.push({
                employee_position: employeePositions[j].position,
                toast_position: mappedToastPosition
            });
        }

        return angular.copy(employeeMappedPositions);
    };

    self.prefillWageDetails = function () {
        var defer = $q.defer();
        var promises = {};
        var prospect_ids = [];
        var application_ids =[];
        self.loading = true;

        if (!self.teamStyle) {
            for (var i in self.employees) {
                var employee = self.employees[i];
                if (employee.prospect_id) {
                    prospect_ids.push(employee.prospect_id)
                }
                if (employee.application_id) {
                    application_ids.push(employee.application_id)
                }
            }
            if (self.isPayrollServiceEnabled) {
                promises['usersDetails'] = OnBoardingAPI.getPayrollUserDetails(prospect_ids, application_ids);
            }
        } else {
            promises['payInformation'] = TeamAPI.getCurrentActiveFinancials(self.brandId, self.employees[0].team_user_id, "ACTIVE");
        }

        $q.all(promises)
            .then(function (result) {

                var usersDetails = result['usersDetails'] || [];
                var payInformation = (result['payInformation'] && result['payInformation'].financials) || [];

                for (var i in self.employees) {
                    var employee = self.employees[i];
                    var employeeDetails = _.find(usersDetails, function (item) {
                        return ((item.prospect_id === employee.prospect_id) || (item.application_id === employee.application_id));
                    }) || {};
                    for (var i in employee.employeeMappedPositions) {
                        if (!self.teamStyle) {
                            employee.employeeMappedPositions[i].employee_position.pay_rate = {};
                            if (employeeDetails && employeeDetails.compensation && employeeDetails.salaray) {
                                employee.employeeMappedPositions[i].employee_position.pay_rate.type = employeeDetails.compensation == "PER_HOUR" ? "HOURLY" : null;
                                employee.employeeMappedPositions[i].employee_position.pay_rate.rate = parseFloat(employeeDetails.salaray);
                                employee.employeeMappedPositions[i].editablePayType = employee.employeeMappedPositions[i].employee_position.pay_rate.type ? false : true;
                            } else {
                                employee.employeeMappedPositions[i].editablePayType = true;
                            }
                        }
                        else {
                            self.hasPermissionToAccessWages = true;
                            if (payInformation.length) {
                                var payType = payInformation[0].pay_type && payInformation[0].pay_type.type;
                                if (payType === "SALARIED") {
                                    if (payInformation[0].annual_rate) {
                                        employee.employeeMappedPositions[i].employee_position.pay_rate = {};
                                        employee.employeeMappedPositions[i].employee_position.pay_rate.type = payType;
                                        employee.employeeMappedPositions[i].employee_position.pay_rate.rate = payInformation[0].annual_rate.value / 100;
                                    }
                                } else if (payType === "HOURLY") {
                                    var payInformationPositons = payInformation[0].positions;
                                    for (var j in payInformationPositons) {
                                        if (payInformationPositons[j].position.code === employee.employeeMappedPositions[i].employee_position.code && payInformationPositons[j].pay_rate) {
                                            employee.employeeMappedPositions[i].employee_position.pay_rate = {};
                                            employee.employeeMappedPositions[i].employee_position.pay_rate.type = payType;
                                            employee.employeeMappedPositions[i].employee_position.pay_rate.rate = payInformationPositons[j].pay_rate.rate;
                                        }
                                    }
                                }

                            }
                        }
                    }
                }

            }).catch(function (err) {
            if (err.status === 403) {
                self.hasPermissionToAccessWages = false;
            }
            console.error(err);
        }).finally(function () {
            delete self.loading;
        });
        return defer.promise;
    };

    self.load = function (brandId, employees, teamStyle) {
        self.loading = true;
        self.teamStyle = teamStyle;
        self.employees = employees;
        self.brandId = brandId;
        self.isBulkSend = self.employees && self.employees.length > 1;
        self.syncWages = false;
        self.hasPermissionToAccessWages = true;

        var promises = {};
        promises['toastMappedPositions'] = posIntegrationService.getToastPositionMapping(self.brandId);
        promises['syncSettings'] = PerformanceAggregatorAPI.getPOSSyncSettings(self.brandId, 'TOAST_SYNC');
        promises['isPayrollServiceEnabled'] = brandServices.check(brandServices.SERVICES.PAYROLL, self.brandId);

        $q.all(promises)
            .then(function (result) {
                var toastMappedPositions = result['toastMappedPositions'];
                var syncSettings = result['syncSettings'];
                self.isPayrollServiceEnabled = result['isPayrollServiceEnabled'] || false;

                if (!self.isBulkSend) {
                    var employee = self.employees[0];
                    self.data.first_name = employee.first_name;
                    self.data.last_name = employee.last_name;
                    self.data.email = employee.email;
                    self.data.team_user_id = employee.team_user_id;
                }
                for (var i in self.employees) {
                    var employee = self.employees[i];
                    employee.employeeMappedPositions = mapEmployeePositionsToToastPositions(employee.positions, toastMappedPositions);
                    for (var i in employee.employeeMappedPositions) {
                        self.submitDisabled = self.submitDisabled && !employee.employeeMappedPositions[i].toast_position;
                        self.showConfirm = self.showConfirm || !employee.employeeMappedPositions[i].toast_position;
                    }
                }
                for (var i in syncSettings) {
                    if (syncSettings[i].code === "TOAST_SYNC_WAGES" && syncSettings[i].value === "1") {
                        self.syncWages = true;
                    }
                }
            }).catch(function (err) {
                console.error(err);
            }).finally(function () {
                if (self.syncWages) {
                    self.prefillWageDetails().then(function () {
                        delete self.loading;
                    })
                } else {
                    delete self.loading;
                }
            });
    };

    self.doSave = function (dataToSend, notMappedPostions) {
        var defer = $q.defer();
        posIntegrationService.sendToToast(self.brandId, dataToSend)
            .then(function (result) {
                var notMappedPositionMessage = "";
                if (result.employees && result.employees[0] && result.employees[0].errors && result.employees[0].errors.length) {
                    var errMessage = self.data.first_name + " " + self.data.last_name + " " + $filter("translate")("was not sent to toast.");
                    errMessage = errMessage + "<br/>" + result.employees[0].errors[0];
                    hAlert($filter("translate")("Error while sending employee"), errMessage);
                    defer.reject();
                } else {
                    HNotifications.show({
                        title: $filter("translate")("Success"),
                        desc: $filter("translate")("Sent successfully to toast"),
                        icon: "fa-check-circle",
                        type: "success",
                        timeout: 20000
                    });
                    if (notMappedPostions.length) {
                        notMappedPositionMessage = $filter("translate")("The following unmapped positions where not synced") + ': ';
                        for (var i in notMappedPostions) {
                            notMappedPositionMessage = notMappedPositionMessage + notMappedPostions[i].name;
                            if (i != notMappedPostions.length - 1) {
                                notMappedPositionMessage = notMappedPositionMessage + ', ';
                            }
                        }
                        HNotifications.show({
                            desc: notMappedPositionMessage,
                            icon: "fa-warning",
                            type: "warning",
                            timeout: 20000
                        });
                    }
                    defer.resolve(result.employees[0]);
                }
            })
            .catch(function (err) {
                defer.reject();
                hAlert($filter("translate")("Error!"), $filter("translate")("something wrong happened, please try again later."));
                console.error(err);
            })
            .finally(function () {
                delete self.saving;
            });
        return defer.promise;
    };


    self.save = function () {
        var defer = $q.defer();
        var dataToSend = [];
        var notMappedPostions = [];
        var postionsWithNoWageDetails = [];
        if (self.validator.validate()) {
            self.saving = true;
            if (!self.isBulkSend) {
                self.data.positions = [];

                for (var i in self.employees[0].employeeMappedPositions) {
                    if (self.employees[0].employeeMappedPositions[i]['toast_position']) {
                        self.data.positions.push(self.employees[0].employeeMappedPositions[i]['employee_position']);
                    }
                    else {
                        notMappedPostions.push(self.employees[0].employeeMappedPositions[i].employee_position);
                    }
                    if (self.syncWages) {
                        if (!self.employees[0].employeeMappedPositions[i].employee_position.pay_rate) {
                            postionsWithNoWageDetails.push(self.employees[0].employeeMappedPositions[i].employee_position.name);
                            self.showMissingDataWarrning = true;
                        }
                        else {
                            if (self.employees[0].employeeMappedPositions[i].employee_position.pay_rate.type != self.employees[0].employeeMappedPositions[i].toast_position.position_pos_pay_type) {
                                delete self.employees[0].employeeMappedPositions[i].employee_position.pay_rate;
                                self.differentPayTypeWarrning = true;
                            }

                        }
                    }

                }
                dataToSend.push(self.data);
            } else {

                var notSentEmployee = _.filter(self.employees, function (employee) {
                    return !employee.pos_id
                });

                dataToSend = _.map(notSentEmployee, function (employee) {
                    var employeePosition = [];
                    for (var i in employee.employeeMappedPositions) {
                        if (employee.employeeMappedPositions[i]['toast_position']) {
                            employeePosition.push(employee.employeeMappedPositions[i]['employee_position']);
                        }
                        if (self.syncWages) {
                            if (employee.employeeMappedPositions[i].employee_position.pay_rate.type != employee.employeeMappedPositions[i].toast_position.position_pos_pay_type) {
                                delete employee.employeeMappedPositions[i].employee_position.pay_rate;
                                self.differentPayTypeWarrning = true;
                            }
                        }
                    }
                    return {
                        team_user_id: employee.team_user_id,
                        first_name: employee.first_name,
                        last_name: employee.last_name,
                        email: employee.email,
                        positions: employeePosition
                    };
                });
            }
            if (self.differentPayTypeWarrning || self.showMissingDataWarrning) {
                var message = '';
                if (self.differentPayTypeWarrning) {
                    message = $filter("translate")("The mapped toast position is not defined with the same employee pay type, sending the employee data will result in syncing the position without the wage data, Are you sure you want to proceed and only sync positions that have the same pay type?");
                } else {
                    var postions = '';
                    if (postionsWithNoWageDetails.length) {
                        postions = postionsWithNoWageDetails.join(', ');
                    }
                    message = $filter("translate")("The following positions are missing wage data due to it being scheduled in the future or not being defined:");
                    message = message + ' ' + postions + ', ';
                    message = message + $filter("translate")("By syncing the position will be synced without wages.");
                }
                hConfirm({
                    title: $filter("translate")("Warning"),
                    text: message,
                    confirmButton: $filter("translate")("Send"),
                    cancelButton: $filter("translate")("Cancel"),
                    callback: function (confirmed) {
                        if(confirmed) {
                            self.doSave(dataToSend, notMappedPostions)
                                .then(function (result) {
                                    defer.resolve(result)
                                }).catch(function (err) {
                                defer.reject(err);
                            });
                        }
                        else {
                            delete self.saving;
                        }
                    }});
            }
            else {
                self.doSave(dataToSend, notMappedPostions)
                    .then(function (result) {
                        defer.resolve(result)
                    }).catch(function (err) {
                    defer.reject(err);
                });
            }
        }

        return defer.promise;
    };
};